import { returnFullResponseHandler } from '../api/api';
import { parseData, post } from './common';
export const createCompanyACHAccount = async (companyAchAccount, payrollExpertsRun) => {
    const resp = await post('/InternalAPI/CompanyACHAccountAPI.asmx/CreateCompanyACHAccount', {
        CompanyACHAccount: companyAchAccount,
        PayrollExpertsRun: payrollExpertsRun
    });
    const serverResponse = await parseData(resp);
    return returnFullResponseHandler(serverResponse);
};
export const updateCompanyACHAccount = async (companyAchAccount, payrollExpertsRun) => {
    const resp = await post('/InternalAPI/CompanyACHAccountAPI.asmx/UpdateCompanyACHAccount', {
        CompanyACHAccount: companyAchAccount,
        PayrollExpertsRun: payrollExpertsRun
    });
    const serverResponse = await parseData(resp);
    return returnFullResponseHandler(serverResponse);
};
